// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/stop-bars.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/stop-bars/stop-bars.js';

mount([g0]);
